export const COMPLETED_ORDER_STATUS = "เสร็จสิ้น";

// Only a new completion transition establishes a date. Editing an old completed
// order must not invent its completion date from updatedAt or receiptDate.
export const getOrderCompletionFields = (previousOrder, nextStatus, now = new Date()) => {
  const previous = previousOrder || {};
  const status = nextStatus === undefined ? previous.status : nextStatus;
  return {
    completedAt: status === COMPLETED_ORDER_STATUS
      ? previous.status === COMPLETED_ORDER_STATUS
        ? previous.completedAt || null
        : now
      : null,
  };
};
